export const hrAccionesRoles = {
  sharedActions: {
    uploads: ['Admin', 'HumanResources'],
  },

  routerActions: {
    root: ['Admin', 'HumanResources'],
  },

  sideNavActions: {
    root: ['Admin', 'HumanResources'],
  },
};
